import { RestrictionEnum } from "@api-types/restriction/RestrictionEnum";
import { getMvcApplicationHeaders, getWebApiUrl, UserTypes } from "@utils";
import { httpClient } from "@utils/http/httpClient";

export default class RestrictionApiService {
	private static get baseUrl(): string {
		return `${getWebApiUrl()}/api/restriction`;
	}

	static getRequestHeaders = (
		user: UserTypes = UserTypes.PRIMARY
	): HeadersInit => {
		const appHeaders = getMvcApplicationHeaders(user);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		appHeaders["Web-Device" as keyof HeadersInit] = "CapacitorApp";
		return appHeaders;
	};

	static async getRestrictionType(): Promise<RestrictionEnum> {
		try {
			const { restrictionType } = await httpClient.get(
				this.baseUrl,
				this.getRequestHeaders(),
				{
					responseType: "json",
				}
			);
			return restrictionType;
		} catch (error) {
			console.log(error);
			return RestrictionEnum.None;
		}
	}
}
